/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-11-25 13:05:57
 * @LastEditTime: 2026-03-11 23:59:49
 * @LastEditors: 赵大壮 372839241@qq.com
 */
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeLayout from "../layout/HomeLayout.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  /**
   * 登录
   */
  {
    path: "/login",
    name: "login",
    meta: { title: "登录" },
    component: () => import("@/views/登录/view/Index.vue"),
  },

  /**
   * 欢迎页
   */
  {
    path: "/",
    component: HomeLayout,
    children: [
      {
        path: "/",
        name: "hello",
        meta: { title: "欢迎", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/z页面模板/Index.vue"),
      }
    ],
  },

  /**
   * 审核管理
   */
  {
    path: "/auditing",
    component: HomeLayout,
    redirect: "/land/list",
    children: [
      {
        path: "/land/list",
        name: "landList",
        meta: { title: "土地管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/土地管理/Index.vue"),
      },
      {
        path: "/land/info",
        name: "landInfo",
        meta: { title: "土地详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/土地管理/Info.vue"),
      },
      {
        path: "/homestay/list",
        name: "homestayList",
        meta: { title: "民宿管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/民宿管理/Index.vue"),
      },
      {
        path: "/homestay/info",
        name: "homestayInfo",
        meta: { title: "民宿详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/民宿管理/Info.vue"),
      },
      {
        path: "/demand/list",
        name: "demandList",
        meta: { title: "需求管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/需求管理/Index.vue"),
      },
      {
        path: "/demand/info",
        name: "demandInfo",
        meta: { title: "需求详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/需求管理/Info.vue"),
      },
      {
        path: "/courtship/list",
        name: "courtshipList",
        meta: { title: "招商管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/招商管理/Index.vue"),
      },
      {
        path: "/courtship/info",
        name: "courtshipInfo",
        meta: { title: "招商详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/审核管理/view/招商管理/Info.vue"),
      },
    ],
  },

  /**
   * 评测管理
   */
  {
    path: "/review",
    component: HomeLayout,
    redirect: "/review",
    children: [
      {
        path: "/land/review",
        name: "landReview",
        meta: { title: "土地评测", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/评测管理/view/土地评测/Index.vue"),
      },
      {
        path: "/land/reviewInfo",
        name: "landReviewInfo",
        meta: { title: "评测详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/评测管理/view/土地评测/Info.vue"),
      }
    ],
  },
  /**
   * 用户管理
   */
  {
    path: "/user",
    component: HomeLayout,
    redirect: "/user/normallist",
    children: [
      {
        path: "/user/normallist",
        name: "userList",
        meta: { title: "用户管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/用户管理/view/普通用户/Index.vue"),
      },
      {
        path: "/user/zqlist",
        name: "zqList",
        meta: { title: "政企管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/用户管理/view/政企用户/Index.vue"),
      }
    ],
  },

  /**
  * 代理商管理
  */
  {
    path: "/agent",
    component: HomeLayout,
    redirect: "/agent/list",
    children: [
      {
        path: "/agent/list",
        name: "agentList",
        meta: { title: "代理商管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/代理商管理/view/Index.vue"),
      }
      /*{
        path: "/agent/auditing",
        name: "agentAuditing",
        meta: { title: "代理商审核", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/代理商管理/view/代理商审核/Index.vue"),
      }*/
    ],
  },

  /**
 * 字典管理
 */
  {
    path: "/dic",
    component: HomeLayout,
    redirect: "/dic/list",
    children: [
      {
        path: "/dic/list",
        name: "dicList",
        meta: { title: "字典管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/字典管理/view/字典列表/Index.vue"),
      },
      {
        path: "/dic/type",
        name: "dicType",
        meta: { title: "分类管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/字典管理/view/分类管理/Index.vue"),
      },
      {
        path: "/dic/label",
        name: "dicLabel",
        meta: { title: "标签管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/字典管理/view/标签管理/Index.vue"),
      }
    ],
  },

  /**
   * 系统管理
   */
  {
    path: "/system",
    component: HomeLayout,
    redirect: "/system/menu",
    children: [
      {
        path: "/system/menu",
        name: "systemMenu",
        meta: { title: "权限管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统管理/view/权限管理/Index.vue"),
      },
      {
        path: "/system/role",
        name: "systemRole",
        meta: { title: "角色管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统管理/view/角色管理/Index.vue"),
      },
      {
        path: "/system/roleInfo",
        name: "systemRoleInfo",
        meta: { title: "角色详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统管理/view/角色详情/Index.vue"),
      },
      {
        path: "/system/admin",
        name: "systemAdmin",
        meta: { title: "管理员管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统管理/view/管理员管理/Index.vue"),
      }
    ],
  },

  /**
   * 订单管理
   */
  {
    path: "/order",
    component: HomeLayout,
    redirect: "/land/order",
    children: [
      {
        path: "/land/order",
        name: "landOrder",
        meta: { title: "土地订单", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/订单管理/土地/view/Index.vue"),
      },
      {
        path: "/homestay/order",
        name: "homestayOrder",
        meta: { title: "民宿订单", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/订单管理/民宿/view/Index.vue"),
      }
    ],
  },

  /**
   * 资讯管理
   */
  {
    path: "/information",
    component: HomeLayout,
    redirect: "/information/list",
    children: [
      {
        path: "/information/list",
        name: "informationList",
        meta: { title: "资讯列表", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/资讯管理/view/资讯列表/Index.vue"),
      },
      {
        path: "/information/type",
        name: "informationType",
        meta: { title: "分类管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/资讯管理/view/分类管理/Index.vue"),
      },
      {
        path: "/information/info",
        name: "informationInfo",
        meta: { title: "资讯详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/资讯管理/view/资讯详情/Index.vue"),
      }
    ],
  },

  /**
   * 百科管理
   */
  {
    path: "/wikipedia",
    component: HomeLayout,
    redirect: "/wikipedia/list",
    children: [
      {
        path: "/wikipedia/list",
        name: "wikipediaList",
        meta: { title: "百科列表", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/百科管理/view/百科列表/Index.vue"),
      },
      {
        path: "/wikipedia/label",
        name: "wikipediaLabel",
        meta: { title: "标签管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/百科管理/view/标签管理/Index.vue"),
      },
      {
        path: "/wikipedia/type",
        name: "wikipediaType",
        meta: { title: "分类管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/百科管理/view/分类管理/Index.vue"),
      },
      {
        path: "/wikipedia/info",
        name: "wikipediaInfo",
        meta: { title: "百科详情", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/百科管理/view/百科详情/Index.vue"),
      }
    ],
  },

  /**
  * 系统设置
  */
  {
    path: "/setting",
    component: HomeLayout,
    redirect: "/setting/city",
    children: [
      {
        path: "/setting/city",
        name: "settingCity",
        meta: { title: "开通城市", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/开通城市/Index.vue"),
      },
      {
        path: "/setting/cityList",
        name: "settingCityList",
        meta: { title: "城市列表", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/城市列表/Index.vue"),
      },
      {
        path: "/setting/set",
        name: "settingList",
        meta: { title: "系统参数", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/系统参数/Index.vue"),
      },
      {
        path: "/setting/version",
        name: "settingVersion",
        meta: { title: "版本管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/版本管理/Index.vue"),
      },
      {
        path: "/setting/suggest",
        name: "suggest",
        meta: { title: "搜索推荐", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/搜索推荐/Index.vue"),
      },
      {
        path: "/setting/links",
        name: "links",
        meta: { title: "友情链接", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/系统设置/view/友情链接/Index.vue"),
      }
    ],
  },

  /**
   * banner管理
   */
  {
    path: "/banner",
    component: HomeLayout,
    redirect: "/banner/list",
    children: [
      {
        path: "/banner/list",
        name: "bannerList",
        meta: { title: "banner管理", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/banner管理/view/Index.vue"),
      }
    ],
  },
  /**
   * 网站信息
   */
  {
    path: "/about",
    component: HomeLayout,
    children: [
      {
        path: "/about",
        name: "about",
        meta: { title: "网站信息", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/网站信息/Index.vue"),
      }
    ],
  },
  /**
   * 提示文本 【用户风险提示、土地状态说明】
   */
  {
    path: "/tips",
    component: HomeLayout,
    children: [
      {
        path: "/tips",
        name: "tips",
        meta: { title: "提示文本", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/提示文本/Index.vue"),
      }
    ],
  },
  /**
   * 支付记录
   */
  {
    path: "/paylog",
    component: HomeLayout,
    children: [
      {
        path: "/paylog",
        name: "paylog",
        meta: { title: "支付记录", bool_widthFull: "1", keepAlive: true },
        component: () => import("@/views/支付管理/view/Index.vue"),
      }
    ],
  }
];

export default new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
